import { translateFn } from '../../../../../../../utils/translator.helper';
import { WhitelistedDomainItem } from '@nirvana/shared/dtos/types/policies/common';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { RegexValidator } from '../../../../../../../ui/gzForm/validators/regex.validator';
import { MaxLengthValidator } from '../../../../../../../ui/gzForm/validators/max-length.validator';

const DOMAIN_MAX_LENGTH = 1024;

// get validators for domains field
export const domainsValidator = (): FormValidator<string>[] => {
  return [
    RegexValidator(/^(?!https?:\/\/)([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i, translateFn('Invalid domain address.')),
    RequiredValidator(translateFn('This field is required.')),
    MaxLengthValidator(
      DOMAIN_MAX_LENGTH,
      translateFn('The domain address must not exceed {domainMaxLength} characters.', {
        domainMaxLength: DOMAIN_MAX_LENGTH,
      })
    ),
  ];
};

// validate duplicates
export function validateDuplicates(item: WhitelistedDomainItem, itemInGrid: WhitelistedDomainItem[]): ValidationResult {
  const hasDuplicates = itemInGrid.some((locationInGrid: WhitelistedDomainItem) => locationInGrid.name === item.name);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
